import { createAction } from '@reduxjs/toolkit'

export const markExtensionPassedReview = createAction(
  'extensionVersionsView/markExtensionPassedReview'
)
